import type { ReactNode } from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';

/**
 * Строка таблицы: объединяет className из styled-components (rest) с rowClassName,
 * курсор-pointer при onRowClick. Элементы с классом `dontRowClick` клик по строке
 * не обрабатывают.
 */
export interface DataTableRowProps {
  tableRow?: any;
  rowClassName?: string | ((tableRow: any) => string | undefined | null);
  onRowClick?: (tableRow: any) => void;
  children?: ReactNode | ((props: any) => ReactNode);
  /** Приходит из styled-components. */
  className?: string;
  [key: string]: any;
}

const DataTableRow = (props: DataTableRowProps) => {
  const {
    tableRow,
    rowClassName,
    onRowClick,
    children,
    ...rest
  } = props;

  // ✅ Объединяем className из styled-components (rest) с rowClassName
  const combinedClassName = [rest.className, (typeof rowClassName === 'function') ? rowClassName(tableRow) : rowClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <Table.Row
      { ...(rest as any) } /* row/tableRow приходят из dx rowComponent, в типе они optional — runtime 1:1 */
      className={ combinedClassName || undefined }
      style={ { cursor: onRowClick ? 'pointer' : 'initial' } }
      onClick={ (e: any) => {
        // dontRowClick - этим классом обозначаем элементы, которые не  должны обрабатывать rowClick
        return onRowClick && (e.target.className.indexOf('dontRowClick') < 0) && onRowClick(tableRow);
      } }
    >
      { (typeof children === 'function') ? children({ ...rest, tableRow }) : children }
    </Table.Row>
  );
};

export default DataTableRow;
